import { createTicketApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Single Ticket API instance for the web client — endpoint definitions live in
 * @trackly/shared (createTicketApi); only the authenticated baseQuery is web-specific.
 */
export const ticketApi = createTicketApi(createAuthenticatedBaseQuery(apiBaseUrl, 'Ticket API'));
